<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Header :showGoBack="true" />

    <main
      :class="'scrollable container'"
      :style="{paddingTop: '10px', paddingBottom: '20px'}"
    >
      <!-- Choose currency -->
      <section :style="{marginBottom: '30px'}">
        <span
          :class="'t14'"
          :style="{marginBottom: '10px', display: 'block'}"
          >Choose currency</span
        >
        <ul
          :class="'row-center'"
          :style="{gap: '11px'}"
        >
          <li
            v-for="(currency, index) in currencies"
            :key="index"
            :style="{
              width: '100%',
              height: '30px',
              border: '1px solid #FFEFE6',
              borderRadius: '6px',

              backgroundColor: 'var(--white-color)',
              borderColor:
                currency === selectedCurrency ? '#040325' : '#6C6D84',
              backgroundColor:
                currency === selectedCurrency ? '#040325' : 'var(--white-color',
            }"
            :class="'clickable center'"
            @click="setCurrency(currency)"
          >
            <span
              :class="'t14'"
              :style="{
                color:
                  currency === selectedCurrency
                    ? 'var(--white-color)'
                    : 'var(--main-dark)',
              }"
              >{{ currency }}</span
            >
          </li>
        </ul>
      </section>

      <!-- Choose deposit period -->
      <section :style="{marginBottom: '30px'}">
        <span
          :class="'t14'"
          :style="{
            display: 'block',
            marginBottom: '10px',
            marginBottom: '10px',
          }"
          >Choose deposit period</span
        >
        <ul
          :style="{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            columnGap: '10px',
          }"
        >
          <li
            :style="{
              display: 'flex',
              flexDirection: 'column',
              height: '110px',
              borderRadius: '6px',
              backgroundColor: '#FFF7F2',
            }"
            :class="'center'"
          >
            <span
              class="'t12'"
              :style="{color: 'var(--main-color)'}"
              >You rate</span
            >
            <span
              :style="{
                fontSize: '24px',
                color: 'var(--main-color)',
              }"
              >13 %</span
            >
          </li>
          <li :style="{height: '110px'}">
            <ul
              :style="{
                display: 'flex',
                height: '100%',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }"
            >
              <li
                :style="{
                  borderRadius: '6px',
                  border: '1px solid #FFEFE6',
                  borderColor:
                    selectedDepositPeriod === period ? '#040325' : '#6C6D84',
                  height: '30px',
                  backgroundColor:
                    selectedDepositPeriod === period
                      ? '#040325'
                      : 'var(--white-color)',
                }"
                v-for="(period, index) in depositPeriods.slice(0, 3)"
                :key="index"
                :class="'center clickable'"
                @click="setDepositPeriod(period)"
              >
                <span
                  :class="'t14'"
                  :style="{
                    color:
                      selectedDepositPeriod === period
                        ? 'var(--white-color)'
                        : 'var(--main-dark)',
                  }"
                >
                  {{ period }}
                </span>
              </li>
            </ul>
          </li>
          <li :style="{height: '110px'}">
            <ul
              :style="{
                display: 'flex',
                height: '100%',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }"
            >
              <li
                :style="{
                  borderRadius: '6px',
                  border: '1px solid #FFEFE6',
                  borderColor:
                    selectedDepositPeriod === period ? '#040325' : '#6C6D84',
                  height: '30px',
                  backgroundColor:
                    selectedDepositPeriod === period
                      ? '#040325'
                      : 'var(--white-color)',
                }"
                v-for="(period, index) in depositPeriods.slice(3, 6)"
                :key="index"
                :class="'center clickable'"
                @click="setDepositPeriod(period)"
              >
                <span
                  :class="'t14'"
                  :style="{
                    color:
                      selectedDepositPeriod === period
                        ? 'var(--white-color)'
                        : 'var(--main-dark)',
                  }"
                >
                  {{ period }}
                </span>
              </li>
            </ul>
          </li>
        </ul>
      </section>

      <!-- Amount -->
      <section :style="{marginBottom: '30px'}">
        <span :class="'t14'">Amount</span>
        <Input
          :placeholder="'Enter amount'"
          :leftIcon="DollarSvg"
          :containerStyle="{marginTop: '10px'}"
        />
      </section>

      <!-- Calculated monthly repayment -->
      <section :style="{marginBottom: '30px'}">
        <span
          :class="'t14'"
          :style="{marginBottom: '10px', display: 'block'}"
          >Calculated monthly repayment</span
        >
        <div
          class="input-container row-center"
          :style="[
            {
              gap: '14px',
              width: '100%',
              backgroundColor: 'var(--white-color)',
              padding: '8px',
              borderRadius: '10px',
              border: '1px solid #ffefe6',
            },
            containerStyle,
          ]"
        >
          <DollarSvg />
          <span :class="'t16'">1 117.00</span>
        </div>
      </section>

      <!-- Early deposit withdrawal -->
      <div :class="'row-center-space-between'">
        <h6>Early loan repayment</h6>
        <Switcher />
      </div>
    </main>

    <section :style="{padding: '20px'}">
      <Button
        :title="'Open New Loan'"
        :onClick="() => $router.push(routes.TAB_NAVIGATOR)"
      />
    </section>
  </div>
</template>

<script setup>
// others
import {ref} from 'vue';
import {routes} from '@/routes';
import {useOpacity} from '@/hooks';

// components
import {Input} from '@/components';
import {Header} from '@/components';
import {Button} from '@/components';
import {Switcher} from '@/components';

// svg
import {DollarSvg} from '@/assets/svg';

const opacity = useOpacity();

const currencies = ['USD', 'EUR'];

const selectedCurrency = ref('USD');

const setCurrency = (currency) => {
  selectedCurrency.value = currency;
};

const depositPeriods = [
  '3 mos',
  '12 mos',
  '24 mos',
  '6 mos',
  '18 mos',
  '36 mos',
];

const selectedDepositPeriod = ref('3 mos');

const setDepositPeriod = (period) => {
  selectedDepositPeriod.value = period;
};
</script>
